import * as actionTypes from './actionTypes'
//import axios from 'axios'

export function getNavigation(navigation) {
	return {
		type: actionTypes.GET_NAVIGATION,
		payload: navigation,
	}
}
